import React from 'react';
import { SubTitle, Description, Image, Link } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const IMAGE = buildImageURL('/sound.jpg');
const IMAGE_M = buildImageURL('/sound-m.jpg');

const track = getTrack({ block: 23 });

export function Sound({mobile = false}) {
  return (
    <div className="page-section section-sound inverted" data-track={track}>
      <div className="txt-wrapper">
        <SubTitle>
          “发烧级”音质<br/>一听入迷
        </SubTitle>
        <Description>
          配备专业HiFi芯片, 为你提供卓越的系统级<br/>音频性能，高保真音频，噪声低至-115dB，<br/>悦耳音质让你为之着迷。
        </Description>
        <Link bordered={false} href="https://shop.vivo.com.cn/product/10006210" text="购买我的X60 Pro+" position={23} />
      </div>
      <Image className="img-wrapper" src={mobile ? IMAGE_M : IMAGE} />
    </div>
  );
}
